exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".extendResultTableContainer---3g7qx {\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto; }\n  .extendResultTableContainer---3g7qx table {\n    width: 100%;\n    border-collapse: collapse; }\n  .extendResultTableContainer---3g7qx table > thead {\n      background-color: #e7e9ea; }\n  .extendResultTableContainer---3g7qx table > thead > tr > td,\n      .extendResultTableContainer---3g7qx table > thead > tr > th {\n        padding-top: 15px;\n        padding-bottom: 10px;\n        font-size: 12px;\n        font-weight: 400;\n        text-transform: uppercase; }\n  .extendResultTableContainer---3g7qx table > tbody > tr > td,\n    .extendResultTableContainer---3g7qx table > tbody > tr > th {\n      padding: 5px; }\n  .extendResultTableContainer---3g7qx table,\n  .extendResultTableContainer---3g7qx th,\n  .extendResultTableContainer---3g7qx td {\n    border: 1px solid #e1e1e1; }\n", ""]);

// exports
exports.locals = {
	"extendResultTableContainer": "extendResultTableContainer---3g7qx"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/extend-result-table/index.scss
// module id = 1166
// module chunks = 3